export default "__VITE_ASSET__DTn5Gkme__"